/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apikeys_Delete_Api_Key_SuccessInputs */



/**
* | output |
* | --- |
* | "API key deleted successfully!" |
*
* @param {Apikeys_Delete_Api_Key_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const apikeys_delete_api_key_success = /** @type {((inputs?: Apikeys_Delete_Api_Key_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apikeys_Delete_Api_Key_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("API-Schlüssel erfolgreich gelöscht!")
	return /** @type {LocalizedString} */ ("API key deleted successfully!")
});